"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HEATMAP_DATA_POINTS_LIMIT = exports.PIE_CHART_LIMIT = void 0;
// (C) 2007-2018 GoodData Corporation
exports.PIE_CHART_LIMIT = 20;
exports.HEATMAP_DATA_POINTS_LIMIT = 10000;
//# sourceMappingURL=limits.js.map